import { useState, useEffect } from 'react'

import type { CustomGridBreakpointKey } from '@/types/dashboard-types'

export function useBreakpointManager(
  isEditMode: boolean,
  defaultBreakpoint: CustomGridBreakpointKey,
  onUnsavedChangesChange?: (hasUnsaved: boolean) => void
) {
  const [editingBreakpoint, setEditingBreakpoint] = useState<CustomGridBreakpointKey | null>(
    isEditMode ? defaultBreakpoint : null
  )
  const [unsavedBreakpoint, setUnsavedBreakpoint] = useState<CustomGridBreakpointKey | null>(null)
  const [pendingBreakpointSwitch, setPendingBreakpointSwitch] = useState<CustomGridBreakpointKey | null>(null)
  const [showUnsavedModal, setShowUnsavedModal] = useState(false)
  const [userHasInteracted, setUserHasInteracted] = useState(false)

  useEffect(() => {
    if (!isEditMode) {
      setUserHasInteracted(false)
      setUnsavedBreakpoint(null)
      onUnsavedChangesChange?.(false)
      setEditingBreakpoint(null)
    } else if (editingBreakpoint === null) {
      setEditingBreakpoint(defaultBreakpoint)
    }
  }, [isEditMode, defaultBreakpoint, editingBreakpoint, onUnsavedChangesChange])

  useEffect(() => {
    setUserHasInteracted(false)
  }, [editingBreakpoint])

  const handleBreakpointChangeRequest = (newBreakpoint: CustomGridBreakpointKey) => {
    if (unsavedBreakpoint && unsavedBreakpoint !== newBreakpoint) {
      setPendingBreakpointSwitch(newBreakpoint)
      setShowUnsavedModal(true)
    } else {
      setEditingBreakpoint(newBreakpoint)
    }
  }

  const handleCancelSwitch = () => {
    setPendingBreakpointSwitch(null)
    setShowUnsavedModal(false)
  }

  return {
    editingBreakpoint,
    setEditingBreakpoint,
    unsavedBreakpoint,
    setUnsavedBreakpoint,
    pendingBreakpointSwitch,
    showUnsavedModal,
    userHasInteracted,
    setUserHasInteracted,
    handleBreakpointChangeRequest,
    handleCancelSwitch,
  }
}
